import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d9f4007a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d9f4007a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f4007a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9f4007a')) {
      api.createRecord('d9f4007a', component.options)
    } else {
      api.reload('d9f4007a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d9f4007a&scoped=true", function () {
      api.rerender('d9f4007a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/analytics-tabs/components/attorney-data/index.vue"
export default component.exports